import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const LockIcon = ({ width, height, fill, margin, ...props }) => {
  return (
    <SvgIcon {...props} style={{ width, height, fill, margin }} viewBox="0 0 7 9">
      <path d="M0.833333 8.75C0.604167 8.75 0.407986 8.6684 0.244792 8.50521C0.0815972 8.34201 0 8.14583 0 7.91667V3.75C0 3.52083 0.0815972 3.32465 0.244792 3.16146C0.407986 2.99826 0.604167 2.91667 0.833333 2.91667H1.25V2.08333C1.25 1.50694 1.45312 1.01562 1.85938 0.609375C2.26562 0.203125 2.75694 0 3.33333 0C3.90972 0 4.40104 0.203125 4.80729 0.609375C5.21354 1.01562 5.41667 1.50694 5.41667 2.08333V2.91667H5.83333C6.0625 2.91667 6.25868 2.99826 6.42188 3.16146C6.58507 3.32465 6.66667 3.52083 6.66667 3.75V7.91667C6.66667 8.14583 6.58507 8.34201 6.42188 8.50521C6.25868 8.6684 6.0625 8.75 5.83333 8.75H0.833333ZM0.833333 7.91667H5.83333V3.75H3.33333H0.833333V7.91667ZM3.33333 6.66667C3.5625 6.66667 3.75868 6.58507 3.92188 6.42188C4.08507 6.25868 4.16667 6.0625 4.16667 5.83333C4.16667 5.60417 4.08507 5.40799 3.92188 5.24479C3.75868 5.0816 3.5625 5 3.33333 5C3.10417 5 2.90799 5.0816 2.74479 5.24479C2.5816 5.40799 2.5 5.60417 2.5 5.83333C2.5 6.0625 2.5816 6.25868 2.74479 6.42188C2.90799 6.58507 3.10417 6.66667 3.33333 6.66667ZM2.08333 2.91667H4.58333V2.08333C4.58333 1.73611 4.46181 1.44097 4.21875 1.19792C3.97569 0.954861 3.68056 0.833333 3.33333 0.833333C2.98611 0.833333 2.69097 0.954861 2.44792 1.19792C2.20486 1.44097 2.08333 1.73611 2.08333 2.08333V2.91667Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833333 7.91667H5.83333V3.75H3.33333H0.833333V7.91667ZM3.92188 6.42188C3.75868 6.58507 3.5625 6.66667 3.33333 6.66667C3.10417 6.66667 2.90799 6.58507 2.74479 6.42188C2.5816 6.25868 2.5 6.0625 2.5 5.83333C2.5 5.60417 2.5816 5.40799 2.74479 5.24479C2.90799 5.0816 3.10417 5 3.33333 5C3.5625 5 3.75868 5.0816 3.92188 5.24479C4.08507 5.40799 4.16667 5.60417 4.16667 5.83333C4.16667 6.0625 4.08507 6.25868 3.92188 6.42188Z"
      />
    </SvgIcon>
  );
};

LockIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  margin: PropTypes.string,
};

LockIcon.defaultProps = {
  width: "8px",
  height: "8px",
  fill: "#0033A0",
  margin: "0 3px",
};

export default memo(LockIcon);
